import React from 'react';

import { CheckmarkAnimation } from '@eika/checkmark-animation';

import { useWindowScrollTop } from '../../sporsmalsflyt/hooks';
import CustomerFeedbackLink from '../sporreskjema-button/customer-feedback-link';

import './klage-kvittering.scss';

export const FellesKvittering = ({ successMelding, content }: { successMelding: string; content: JSX.Element }) => {
    return (
        <div className="container__standard-width kvittering">
            <div className="kvittering-checkmark-wrapper">
                <CheckmarkAnimation />
            </div>
            <h1 className="kvittering-header">{successMelding}</h1>

            {content}
        </div>
    );
};

export const KlageKvittering = () => {
    const windowScrollTop = useWindowScrollTop();
    windowScrollTop();
    return (
        <div className="skademelding-kvittering">
            <FellesKvittering
                successMelding="Klagen er sendt inn"
                content={
                    <>
                        <p>En kvittering på mottatt klage sendes til e-postadressen du oppga.</p>
                        <p>
                            Du vil motta en skriftlig bekreftelse og mer informasjon om hva som skjer videre når vi
                            begynner å behandle klagen din.
                        </p>
                    </>
                }
            />
            <CustomerFeedbackLink />
        </div>
    );
};
